import React from 'react'
import { Typography } from '@grammarly/badger-ui'
import { useFormControlContext } from './form-control-context'
import styles from './form.module.scss'

const { C4 } = Typography

export const ErrorText: React.FC = () => {
  const { error, isInvalidContext } = useFormControlContext()
  const hasErrors = !!error
  if (!hasErrors || !isInvalidContext) {
    return null
  }

  return (
    <C4 as="div" className={styles.errorRow}>
      {error}
    </C4>
  )
}

export const errorStyle = styles.errorRow
